import { defineMessages } from "react-intl";
import { TransactionType } from "../../contract/pam.js";
const transactionTypeMessages = defineMessages({
  Deposit: {
    id: "transactionType_Deposit",
    defaultMessage: "Deposit"
  },
  Withdrawal: {
    id: "transactionType_Withdrawal",
    defaultMessage: "Withdrawal"
  },
  Debit: {
    id: "transactionType_Debit",
    defaultMessage: "Debit"
  },
  Credit: {
    id: "transactionType_Credit",
    defaultMessage: "Credit"
  },
  BuyIn: {
    id: "transactionType_BuyIn",
    defaultMessage: "Buy-in"
  },
  BuyOut: {
    id: "transactionType_Buyout",
    defaultMessage: "Buyout"
  },
  Bonus: {
    id: "transactionType_Bonus",
    defaultMessage: "Bonus"
  },
  RevenueShare: {
    id: "transactionType_RevenueShare",
    defaultMessage: "Revenue Share"
  },
  MttCredit: {
    id: "transactionType_MttCredit",
    defaultMessage: "Mtt Credit"
  },
  MttDebit: {
    id: "transactionType_MttDebit",
    defaultMessage: "Mtt Debit"
  },
  PokerAddonCredit: {
    id: "transactionType_PokerAddonCredit",
    defaultMessage: "Poker Addon Credit"
  },
  PokerAddonDebit: {
    id: "transactionType_PokerAddonDebit",
    defaultMessage: "Poker Addon Debit"
  },
  Release: {
    id: "transactionType_Release",
    defaultMessage: "Release"
  },
  PokerFlipsPayout: {
    id: "transactionType_PokerFlipsPayout",
    defaultMessage: "PokerFlips Payout"
  },
  PokerFlipsWager: {
    id: "transactionType_PokerFlipsWager",
    defaultMessage: "PokerFlips Wager"
  },
  CasinoWager: {
    id: "transactionType_CasinoWager",
    defaultMessage: "Casino Wager"
  },
  CasinoPayout: {
    id: "transactionType_CasinoPayout",
    defaultMessage: "Casino Payout"
  },
  CasinoFreeSpinWager: {
    id: "transactionType_CasinoFreeSpinWager",
    defaultMessage: "Casino Free Spin Wager"
  },
  CasinoFreeSpinPayout: {
    id: "transactionType_CasinoFreeSpinPayout",
    defaultMessage: "Casino Free Spin Payout"
  },
  CasinoWagerRefund: {
    id: "transactionType_CasinoWagerRefund",
    defaultMessage: "Casino Wager Refund"
  },
  CasinoPayoutRefund: {
    id: "transactionType_CasinoPayoutRefund",
    defaultMessage: "Casino Payout Refund"
  },
  CasinoFreeSpinWagerRefund: {
    id: "transactionType_CasinoFreeSpinWagerRefund",
    defaultMessage: "Casino Free Spin Wager Refund"
  },
  CasinoFreeSpinPayoutRefund: {
    id: "transactionType_CasinoFreeSpinPayoutRefund",
    defaultMessage: "Casino Free Spin Payout Refund"
  },
  P2PTransferCredit: {
    id: "transactionType_P2PTransferCredit",
    defaultMessage: "P2P Transfer Credit"
  },
  P2PTransferDebit: {
    id: "transactionType_P2PTransferDebit",
    defaultMessage: "P2P Transfer Debit"
  },
  Chargeback: {
    id: "transactionType_Chargeback",
    defaultMessage: "Chargeback"
  },
  Refund: {
    id: "transactionType_Refund",
    defaultMessage: "Refund"
  },
  Reserve: {
    id: "transactionType_Reserve",
    defaultMessage: "Reserve"
  },
  Reverse: {
    id: "transactionType_Reverse",
    defaultMessage: "Reverse"
  },
  LiveEventBuyIn: {
    id: "transactionType_LiveEventBuyIn",
    defaultMessage: "Live Event Buy In"
  },
  SportsBetSettlement: {
    id: "transactionType_SportsBetSettlement",
    defaultMessage: "Sportsbook Bet Settlement"
  },
  SportsBuyin: {
    id: "transactionType_SportsBuyin",
    defaultMessage: "Sportsbook Buy In"
  },
  SportsBuyout: {
    id: "transactionType_SportsBuyout",
    defaultMessage: "Sportsbook Buyout"
  },
  Fee: {
    id: "transactionType_Fee",
    defaultMessage: "Fee"
  },
  FeeReverse: {
    id: "transactionType_FeeReverse",
    defaultMessage: "Fee Reverse"
  },
  Payin: {
    id: "transactionType_Payin",
    defaultMessage: "Pay In"
  },
  Payout: {
    id: "transactionType_Payout",
    defaultMessage: "Pay Out"
  },
  PayoutReturn: {
    id: "transactionType_PayoutReturn",
    defaultMessage: "Payout Return"
  },
  FEES: {
    id: "transactionType_Fees",
    defaultMessage: "Fees"
  }
});
const localizedTypes = {
  [TransactionType.Deposit]: transactionTypeMessages.Deposit,
  [TransactionType.Withdrawal]: transactionTypeMessages.Withdrawal,
  [TransactionType.Debit]: transactionTypeMessages.Debit,
  [TransactionType.Credit]: transactionTypeMessages.Credit,
  [TransactionType.BuyIn]: transactionTypeMessages.BuyIn,
  [TransactionType.BuyOut]: transactionTypeMessages.BuyOut,
  [TransactionType.Bonus]: transactionTypeMessages.Bonus,
  [TransactionType.RevenueShare]: transactionTypeMessages.RevenueShare,
  [TransactionType.MttCredit]: transactionTypeMessages.MttCredit,
  [TransactionType.MttDebit]: transactionTypeMessages.MttDebit,
  [TransactionType.PokerAddonCredit]: transactionTypeMessages.PokerAddonCredit,
  [TransactionType.PokerAddonDebit]: transactionTypeMessages.PokerAddonDebit,
  [TransactionType.Release]: transactionTypeMessages.Release,
  [TransactionType.PokerFlipsPayout]: transactionTypeMessages.PokerFlipsPayout,
  [TransactionType.PokerFlipsWager]: transactionTypeMessages.PokerFlipsWager,
  [TransactionType.CasinoWager]: transactionTypeMessages.CasinoWager,
  [TransactionType.CasinoPayout]: transactionTypeMessages.CasinoPayout,
  [TransactionType.CasinoFreeSpinWager]: transactionTypeMessages.CasinoFreeSpinWager,
  [TransactionType.CasinoFreeSpinPayout]: transactionTypeMessages.CasinoFreeSpinPayout,
  [TransactionType.CasinoWagerRefund]: transactionTypeMessages.CasinoWagerRefund,
  [TransactionType.CasinoPayoutRefund]: transactionTypeMessages.CasinoPayoutRefund,
  [TransactionType.CasinoFreeSpinWagerRefund]: transactionTypeMessages.CasinoFreeSpinWagerRefund,
  [TransactionType.CasinoFreeSpinPayoutRefund]: transactionTypeMessages.CasinoFreeSpinPayoutRefund,
  [TransactionType.P2PTransferCredit]: transactionTypeMessages.P2PTransferCredit,
  [TransactionType.P2PTransferDebit]: transactionTypeMessages.P2PTransferDebit,
  [TransactionType.Chargeback]: transactionTypeMessages.Chargeback,
  [TransactionType.Refund]: transactionTypeMessages.Refund,
  [TransactionType.Reserve]: transactionTypeMessages.Reserve,
  [TransactionType.Reverse]: transactionTypeMessages.Reverse,
  [TransactionType.LiveEventBuyIn]: transactionTypeMessages.LiveEventBuyIn,
  [TransactionType.SportsBetSettlement]: transactionTypeMessages.SportsBetSettlement,
  [TransactionType.SportsBuyin]: transactionTypeMessages.SportsBuyin,
  [TransactionType.SportsBuyout]: transactionTypeMessages.SportsBuyout,
  [TransactionType.Fee]: transactionTypeMessages.Fee,
  [TransactionType.FeeReverse]: transactionTypeMessages.FeeReverse,
  [TransactionType.Payin]: transactionTypeMessages.Payin,
  [TransactionType.Payout]: transactionTypeMessages.Payout,
  [TransactionType.PayoutReturn]: transactionTypeMessages.PayoutReturn
};
const localizedTransactionType = localizedTypes;
const localizedTransactionFilterType = {
  ...localizedTypes,
  FEES: transactionTypeMessages.FEES
};
export {
  localizedTransactionFilterType,
  localizedTransactionType
};
//# sourceMappingURL=transactionType.js.map
